let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("9tNcH")).then(() => parcelRequire('c6u22'));